import Vue from 'vue';

let notified = false;

export async function checkVersion() {
  const isLocalEnvironment = process.env.NODE_ENV === 'local' || location.origin.match('localhost');
  if (isLocalEnvironment || notified) return;

  try {
    const currentAppVersion = process.env.CODEBUILD_RESOLVED_SOURCE_VERSION || process.env.APP_VERSION;
    const response = await fetch('/version.json', { cache: 'no-store' });
    const { sha } = await response.json();

    if (sha && currentAppVersion && sha !== currentAppVersion) {
      notified = true;
      Vue.notify({
        group: 'app',
        type: 'warn',
        duration: -1,
        closeOnClick: true,
        text: '<span style="cursor:pointer;text-decoration:underline" onclick="location.reload()">A new version is available — click to refresh</span>'
      });
    }
  } catch (e) {
    console.error(e);
  }
}
